import React from "react";

import { ScheduleRule } from "../../scheduleRule/ScheduleRule";

export const RulePopupPreview = ({ formProps, useShortNotations }) => {
  const { timeStart, timeEnd, selectedDays } = formProps.values;

  return (
    <div className={"rule-popup__preview"}>
      <ScheduleRule
        timeStart={timeStart}
        timeEnd={timeEnd}
        selectedDays={selectedDays}
        useShortNotations={useShortNotations}
      />
    </div>
  );
};
